import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Pagination from 'components/Pagination';
import PackageEditDatesList from 'components/PackageEditDatesList';

import { PackageEditDates_package$key } from '__generated__/PackageEditDates_package.graphql';
import { PackageEditDates_data$key } from '__generated__/PackageEditDates_data.graphql';

type Props = {
  package: PackageEditDates_package$key;
  data: PackageEditDates_data$key;
};

const PackageEditDates: FC<Props> = props => {
  const pack = useFragment(
    graphql`
      fragment PackageEditDates_package on Package {
        ...PackageEditDatesAdd_package
        ...PackageEditDatesList_package @arguments(first: $first)
      }
    `,
    props.package
  );

  const data = useFragment(
    graphql`
      fragment PackageEditDates_data on Query {
        ...PackageEditDatesList_data
      }
    `,
    props.data
  );

  return (
    <Pagination>
      <PackageEditDatesList package={pack} data={data} />
    </Pagination>
  );
};

export default PackageEditDates;
